import {GET_REVIEW_TAGS, CREATE_REVIEW_TAGS, UPDATE_REVIEW_TAGS, DELETE_REVIEW_QUOTE, RESET_REVIEW_TAGS, TOGGLE_IS_SAVED } from '../constants/reviewsConstants';

const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
}

const getTags = (reviewID, urlToReplace) => async (dispatch) => {
    dispatch({type: RESET_REVIEW_TAGS});
    let url = window.location.href;
    url = url.replace(`/${urlToReplace}`,`/review/${reviewID}`);
    await fetch(url, {
        method: 'GET',
        headers: headers,
    }).then(function(response) {
        return response.json();
    }).then(function(myJson) {
        dispatch({ type: GET_REVIEW_TAGS, payload: myJson});
    })
}

const createQuoteTags = (quote, tags, reviewID) => async (dispatch) => {
    let url = window.location.origin;
    url = url + '/vendor_quotes';
    await fetch(url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
            quote: quote,
            quote_tags: tags,
            review_id: reviewID,
        })
    }).then(function(response) {
        return response.json();
    }).then(function(myJson) {
        dispatch({ type: CREATE_REVIEW_TAGS, payload: myJson});
    })
}

const updateQuoteTags = (tags, quoteTagID) => async (dispatch) => {
    let url = window.location.origin;
    url = url + '/vendor_quotes/' + quoteTagID;
    await fetch(url, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify({
            quote_tags: tags,            
        })
    }).then(function(response) {
        return response.json();
    }).then(function(myJson) {
        dispatch({ type: UPDATE_REVIEW_TAGS, payload: myJson});
    })
}

const deleteQuote = (quoteID) => async (dispatch) => {
    let url = window.location.origin;
    url = url + '/vendor_quotes/' + quoteID;
    await fetch(url, {
        method: 'DELETE',
        headers: headers,
    }).then(function(response) {
        return response.json();
    }).then(function(myJson) {
        dispatch({ type: DELETE_REVIEW_QUOTE, payload: quoteID});
    })
}

const toggleIsSaved = () => async (dispatch) => {
    dispatch({ type: TOGGLE_IS_SAVED});
}

export {
    getTags,
    createQuoteTags,
    updateQuoteTags,
    deleteQuote,
    toggleIsSaved
}